jQuery(document).ready(function (jQuery) {
  var wishlist = [];
  var storeditems = JSON.parse(localStorage.getItem("items"));

  if (storeditems != null) {
    for (let i = 0; i <= storeditems.length; i++) {
      jQuery('[data-handle="' + storeditems[i] + '"]').addClass(
        "wishlist-active"
      );
      jQuery.get(
        "/products/" + storeditems[i] + "?view=wishlist",
        function (quick_response) {
          console.log("quick_response");
          jQuery("#wishlist").append(quick_response);
        }
      );
    }
    jQuery("li.wishlist-total span").text(storeditems.length);
  }

  jQuery(document).delegate(".wish-list", "click", function (e) {
    var t = $(this);
    var s = t.data("handle");
    t.toggleClass("wishlist-active");
    var storeditems2;
    if( JSON.parse(localStorage.getItem("items"))){
       storeditems2 = JSON.parse(localStorage.getItem("items"));
      
    }
    else {
      storeditems2 = [];
    }
    // If its not in the wishlist add it
    if(t.hasClass("wishlist-active")) { 
      storeditems2.push(s);
      // console.log("in 1");
      // console.log(storeditems2);
    }
    else {
      // console.log("in 2");
        var index = storeditems2.indexOf(s);
        if (index > -1) {
          storeditems2.splice(index, 1);
        }
    }
    // wishlist.push(s);
    localStorage.setItem("items", JSON.stringify(storeditems2));

    setTimeout(function () {
      for (let i = 0; i <= storeditems.length; i++) {
        if (storeditems[i] == s) {
          localStorage.removeItem(i);
        }
      }
    }, 500);
  });

  jQuery("#CartMenu").on("click", function () {
    jQuery(".cart-side-menu")
      .removeClass("cart-menu-isClosed")
      .addClass("cart-menu-isOpen");
    jQuery("body").addClass("side-menu-open");
  });
  jQuery(".cart-side-menu-close").on("click", function () {
    jQuery(".cart-side-menu")
      .removeClass("cart-menu-isOpen")
      .addClass("cart-menu-isClosed");
    jQuery("body").removeClass("side-menu-open");
  });

  jQuery(".add-to-cart").on("click", function (e) {
    cart_sidebar_open();
    var form = jQuery(this).closest("form");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function (cart) {
        klaviyo(cart);
        // if( yearly_free_status == 'true'){
        //   if( cart.variant_id == 44794297123138){
        //     addDiffuser();
        //   }
        // }
        cart_sidebar_update();
        discountPopup(cart);
        discountPopupSpend();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery(".cart-sidebar .cart-sidebar-loading").hide();
      },
    });
    e.preventDefault();
  });
  function klaviyo(cart) {
    __klaviyo(cart);
  }

  function addDiffuser() {
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { quantity: 1, id: yearly_free_product },
      dataType: "json",
      success: function (cart) {
        klaviyo(cart);
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery(".cart-sidebar .cart-sidebar-loading").hide();
      },
    });
  }

  function cart_sidebar_open() {
    jQuery(".cart-side-menu")
      .removeClass("cart-menu-isClosed")
      .addClass("cart-menu-isOpen _loading");
    jQuery("body").addClass("side-menu-open");
  }

  function cart_sidebar_update() {
    jQuery.getJSON("/cart.js", function (cart) {
      cart_sidebar_update_mini_cart(cart);
      cart_sidebar_update_free_shipping(cart);
      cart_sidebar_update_product(cart);
      cart_sidebar_update_totals(cart);
      //discountPopupSpend(cart);

      jQuery(".cart-sidebar").removeClass("_loading");
      jQuery(".cart-sidebar").removeClass("is_empty");
      jQuery("#cart-items").removeClass("_loading");
      jQuery("#cart-items").removeClass("is_empty");
      if (cart.item_count == 0) {
        jQuery(".cart-sidebar").addClass("is_empty");
        jQuery("#cart-items").addClass("is_empty");
      }
    });
  }

  function cart_sidebar_update_mini_cart(cart) {
    jQuery(".mini-cart-count").text(cart.item_count);
  }
  function cart_sidebar_update_free_shipping(cart) {
    oilty = false;
    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        // console.log("made it in1");
        // console.log(oilty_id_monthly);
        if (oilty_id_monthly) {
          if (cart.items[i].id == oilty_id_monthly) {
            oilty = true;
            oilty_type = "monthly";
          }
        }
        if (oilty_id_annually) {
          if (cart.items[i].id == oilty_id_annually) {
            oilty = true;
            oilty_type = "annually";
          }
        }
      }
    }

    if (is_oilty == true) {
      oilty = true;
    }

    if (oilty == true) {
      var free_shipping_price = 15;
    } else {
      var free_shipping_price = 49.95;
    }

    var free_shipping_away = 0;
    var cart_total_price = parseInt(cart.total_price) / 100;
    var free_shipping_bar = Math.round(
      (cart_total_price * 100) / free_shipping_price
    );

    if (cart_total_price >= free_shipping_price) {
      jQuery(".ajax-cart-free-shipping .progress-bar").css("width", "100%");
      if (free_shipping_price == 15) {
        jQuery(".ajax-cart-free-shipping h3").text(
          "QUALIFIED FOR FREE SHIPPING ($15+)"
        );
      } else {
        jQuery(".ajax-cart-free-shipping h3").text(
          "QUALIFIED FOR FREE SHIPPING ($49.95+)"
        );
      }
    } else {
      free_shipping_away = free_shipping_price - cart_total_price;
      if (free_shipping_away < 1) {
        var free_shipping_bar = 99;
      }
      jQuery(".ajax-cart-free-shipping h3").html(
        "Almost There! Add $<span>" +
          free_shipping_away.toFixed(2) +
          "</span> To Unlock Free Shipping"
      );
      jQuery(".ajax-cart-free-shipping .progress-bar").css(
        "width",
        free_shipping_bar + "%"
      );
    }
  }
  function cart_sidebar_update_product(cart) {
    var template =
      '<li class="__cart_sidebar_{ID} __cart_product_{PRODUCT_ID}" data-id="{ID}"><div class="cart-product-wrap"><div class="cp-image"><a href="{URL}"><img src="{IMAGE}" alt="" width="75"></a></div><div class="cp-detail"><a href="javascript:;" id="RemoveFromCart" data-id="{ID}" class="shoppingcart-remove-item"><i class="remove-icon"></i></a><h6>{NAME}</h6>{PLAN}{OPTION}{DISCOUNT}<div class="items-count"><select name="qty" id="qty_{ID}" data-id="{ID}" class="shoppingcart-item-qty qty_{INDEX}"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option><option value="30">30</option><option value="31">31</option><option value="32">32</option><option value="33">33</option><option value="34">34</option><option value="35">35</option><option value="36">36</option><option value="37">37</option><option value="38">38</option><option value="39">39</option><option value="40">40</option><option value="41">41</option><option value="42">42</option><option value="43">43</option><option value="44">44</option><option value="45">45</option><option value="46">46</option><option value="47">47</option><option value="48">48</option><option value="49">49</option><option value="50">50</option><option value="51">51</option><option value="52">52</option><option value="53">53</option><option value="54">54</option><option value="55">55</option><option value="56">56</option><option value="57">57</option><option value="58">58</option><option value="59">59</option><option value="60">60</option><option value="61">61</option><option value="62">62</option><option value="63">63</option><option value="64">64</option><option value="65">65</option><option value="66">66</option><option value="67">67</option><option value="68">68</option><option value="69">69</option><option value="70">70</option><option value="71">71</option><option value="72">72</option><option value="73">73</option><option value="74">74</option><option value="75">75</option><option value="76">76</option><option value="77">77</option><option value="78">78</option><option value="79">79</option><option value="80">80</option><option value="81">81</option><option value="82">82</option><option value="83">83</option><option value="84">84</option><option value="85">85</option><option value="86">86</option><option value="87">87</option><option value="88">88</option><option value="89">89</option><option value="90">90</option><option value="91">91</option><option value="92">92</option><option value="93">93</option><option value="94">94</option><option value="95">95</option><option value="96">96</option><option value="97">97</option><option value="98">98</option><option value="99">99</option><option value="100">100</option></select><span class="p-price"><span>{OLD_PRICE}</span> {PRICE}</span></div>{DONATION_PRICE}</div></div></li>';
    var ProductList = jQuery(".carts-product-list");
    if (cart.item_count > 0) {
      var oilty_status = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].image) {
          var __image_url = cart.items[i].image;
          var __image_url_array = __image_url.split(".");
          var __image_url_replace =
            "." + __image_url_array[__image_url_array.length - 1];
          var __image_url_new =
            "_75x120@2x." + __image_url_array[__image_url_array.length - 1];
          var __image_url_final = __image_url.replace(
            __image_url_replace,
            __image_url_new
          );
        } else {
          var __image_url_final =
            "https://cdn.shopify.com/s/files/1/0679/7908/4098/files/favicon.png";
        }

        if (i == 0) {
          ProductList.html("");
        }

        if (cart.items[i].id == oilty_id_monthly) {
          var oilty_status = true;
        }
        if (cart.items[i].id == oilty_id_annually) {
          var oilty_status = true;
        }
        var _price = cart.items[i].original_price;
        var discounted_price = cart.items[i].discounted_price;
        var script_discount_note = false;
        var script_discount_notenote;

        for (var key in cart.items[i].properties) {
          if (cart.items[i].properties.hasOwnProperty(key)) {
            // console.log(key + " -> " + cart.items[i].properties[key]);
            if (key === "Discount Note") {
              script_discount_notenote = cart.items[i].properties[key];
              script_discount_note = true;
            }
          }
        }

        if (script_discount_note === true) {
          var price = Shopify.formatMoney(cart.items[i].original_price);
          var old_price = "";
          var discount_title = script_discount_notenote;
          var discount_html =
            '<p><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-{{ settings.accent_icons }}" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></svg> ' +
            discount_title +
            "</p>";
        } else if (_price != discounted_price) {
          var price = Shopify.formatMoney(cart.items[i].discounted_price);
          var old_price = Shopify.formatMoney(cart.items[i].original_price);
          var discount_title = cart.items[i].discounts[0]["title"];
          var discount_html =
            '<p><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-{{ settings.accent_icons }}" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></svg> ' +
            discount_title +
            "</p>";
        } else {
          var old_price = "";
          var price = Shopify.formatMoney(cart.items[i].original_price);
          var discount_html = "";
        }

        var option_html = "";
        if (cart.items[i].options_with_values) {
          for (var p = 0; p < cart.items[i].options_with_values.length; p++) {
            if (cart.items[i].options_with_values[p].value != "Default Title") {
              option_html =
                "<p>" +
                cart.items[i].options_with_values[p].name +
                ": " +
                cart.items[i].options_with_values[p].value +
                "</p>";
            }
          }
        }
        var plan_html = "";
        if (cart.items[i].selling_plan_allocation) {
          plan_html =
            "<p>" +
            cart.items[i].selling_plan_allocation.selling_plan.name +
            "</p>";
        }

        var donation_html = "";
        if (cart.items[i].product_id == "8260603019586") {
          plan_html =
            '<span class="donation-price">' +
            Shopify.formatMoney(cart.items[i].line_price) +
            "</span>";
        }

        var item = template;
        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{INDEX\}/g, i);
        item = item.replace(/\{URL\}/g, cart.items[i].url);
        item = item.replace(/\{NAME\}/g, cart.items[i].product_title);
        item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title || "");
        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(/\{IMAGE\}/g, __image_url_final);
        item = item.replace(/\{OLD_PRICE\}/g, old_price);
        item = item.replace(/\{PRICE\}/g, price);
        item = item.replace(/\{PLAN\}/g, plan_html);
        item = item.replace(/\{OPTION\}/g, option_html);
        item = item.replace(/\{DISCOUNT\}/g, discount_html);
        item = item.replace(/\{DONATION_PRICE\}/g, donation_html);
        item = item.replace(/\{PRODUCT_ID\}/g, cart.items[i].product_id);

        ProductList.append(item);
      }

      if (
        oilty_status == true ||
        is_oilty == true ||
        hide_oilty_signup == true
      ) {
        jQuery(".oilty-plus-cart-sidebar").hide();
      } else {
        jQuery(".oilty-plus-cart-sidebar").show();
        jQuery("#oilty-plus-checkbox").prop("checked", false);
      }

      cart_sidebar_update_dropdown(cart);
    } else {
      ProductList.html("");
      jQuery(".cart-sidebar").addClass("is_empty");
    }
  }

  function cart_sidebar_update_totals(cart) {
    jQuery(".__subtotal").html(Shopify.formatMoney(cart.total_price));
    jQuery(".__total").html(Shopify.formatMoney(cart.total_price));
    jQuery("#cart-value").val(cart.total_price);
  }

  function cart_sidebar_update_dropdown(cart) {
    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        jQuery(".qty_" + i).val(cart.items[i].quantity);
      }
    }
  }

  function cart_sidebar_update_quantity(product_id, quantity) {
    cart_sidebar_open();
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + quantity + "&id=" + product_id,
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery(".cart-sidebar .cart-sidebar-loading").hide();
      },
    });
  }

  jQuery(document).delegate(".shoppingcart-item-qty", "change", function (e) {
    cart_sidebar_update_quantity(
      jQuery(this).attr("data-id"),
      jQuery(this).val()
    );
  });

  jQuery(document).delegate(".shoppingcart-remove-item", "click", function (e) {
    cart_sidebar_open();
    var product_id = jQuery(this).attr("data-id");

    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=0&id=" + product_id,
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        jQuery(".cart-sidebar .cart-sidebar-loading").hide();
      },
    });

    e.preventDefault();
  });

  document.addEventListener("rebuy.add", function () {
    cart_sidebar_update();
  });

  jQuery("#oilty-plus-checkbox").click(function () {
    jQuery(".oilty-plus-add").click();
  });

  jQuery(document).delegate(".add-subscription", "click", function (e) {
    jQuery(".subscribe-remove").show();
    jQuery(".add-subscription").hide();
    jQuery(".selling-option").show();
    jQuery("#selling_plan").val(jQuery("#selling_option").val());
    subscription_update();
  });

  jQuery(document).delegate(".subscribe-remove", "click", function (e) {
    jQuery(".subscribe-remove").hide();
    jQuery(".add-subscription").show();
    jQuery(".selling-option").hide();
    jQuery("#selling_plan").val("");
    subscription_update();
  });

  jQuery(document).delegate("#selling_option", "change", function (e) {
    jQuery("#selling_plan").val(jQuery(this).val());
    //var discount = jQuery(this).find(':selected').attr('data-discount');
    subscription_update();
  });

  jQuery(document).delegate(".subscription__select", "change", function (e) {
    var selected_option = jQuery(this).val().toLowerCase();
    var selling_id = jQuery(".selling_plan_" + selected_option).attr("data-id");
    jQuery("#subscription_selling_plan").val(selling_id);
  });

  function subscription_update() {
    var price = jQuery(".product-subscribe").attr("data-price");
    var compare_price = jQuery(".product-subscribe").attr("data-compare-price");
    //var discount = jQuery('.product-subscribe').attr('data-discount');
    var discount = jQuery("#selling_option")
      .find(":selected")
      .attr("data-discount");
    var selling_plan = jQuery("#selling_plan").val();

    if (selling_plan) {
      var subscription_price = price - (price * discount) / 100;
      var html =
        '<span class="actual-price">' +
        Shopify.formatMoney(price) +
        '</span><strong class="subscribe-price">' +
        Shopify.formatMoney(subscription_price) +
        "<span>" +
        discount +
        "% Off</span></strong>";
      jQuery(".product-price").html(html);
      jQuery(".product-price").addClass("sale");
    } else {
      if (compare_price > price) {
        jQuery(".product-price").addClass("sale");
        var html =
          '<span class="actual-price">' +
          Shopify.formatMoney(compare_price) +
          "</span><strong>" +
          Shopify.formatMoney(price) +
          "</strong>";
        jQuery(".product-price").html(html);
      } else {
        var html =
          '<span class="actual-price"></span><strong>' +
          Shopify.formatMoney(price) +
          "</strong>";
        jQuery(".product-price").removeClass("sale");
        jQuery(".product-price").html(html);
      }
    }
  }

  jQuery(document).delegate(".other-payment", "click", function (e) {
    jQuery(".additional-checkout-buttons").toggleClass("active");
    jQuery(this).toggleClass("active");
    e.preventDefault();
  });

  function discountPopup(cart) {
    var product_id = cart.product_id;
    var product_quantity = cart.quantity;
    if (product_quantity > 9) {
      var product_quantity = 10;
    }
    if (jQuery("#DiscountModal-" + product_id).length > 0) {
      //jQuery(".cart-side-menu").removeClass('cart-menu-isOpen').addClass('cart-menu-isClosed');
      //jQuery("body").removeClass('side-menu-open');

      jQuery("#DiscountModal-" + product_id).modal("show");
      jQuery("#DiscountModal-" + product_id + " .modal-title span.count").text(
        product_quantity
      );
      jQuery("#DiscountModal-" + product_id + " .description span.count").text(
        product_quantity
      );
      jQuery("#DiscountModal-" + product_id).data(
        "data-limit",
        product_quantity
      );

      if (product_quantity > 1) {
        jQuery("#DiscountModal-" + product_id + " .description span.oil").text(
          "Oils"
        );
        jQuery("#DiscountModal-" + product_id + " .modal-title span.oil").text(
          "Oils"
        );
      } else {
        jQuery("#DiscountModal-" + product_id + " .description span.oil").text(
          "Oil"
        );
        jQuery("#DiscountModal-" + product_id + " .modal-title span.oil").text(
          "Oil"
        );
      }

      jQuery(".modal .product-button span")
        .siblings("input")
        .attr("checked", false);
      jQuery(".modal .product-button span").removeClass("disable");
      jQuery(".modal .product-button span").removeClass("active");
      jQuery(".modal .product-button span").text("Select");
    }
  }

  function discountPopupSpend() {
    jQuery.getJSON("/cart.js", function (cart) {
      if (cart.total_price > 7500) {
        if (jQuery("#DiscountModal-75").length > 0) {
          var show_offer = true;
          var campaign = jQuery("#DiscountModal-75").attr("data-campaign");

          for (var i = 0; i < cart.items.length; i++) {
            var _price = cart.items[i].original_price;
            var discounted_price = cart.items[i].discounted_price;
            if (_price != discounted_price) {
              for (var d = 0; d < cart.items[i].discounts.length; d++) {
                var discount_title = cart.items[i].discounts[d]["title"];
                if (discount_title == campaign) {
                  var show_offer = false;
                }
              }
            }
          }

          if (show_offer == true) {
            jQuery("#DiscountModal-75").modal("show");
            jQuery(".modal .product-button span")
              .siblings("input")
              .attr("checked", false);
            jQuery(".modal .product-button span").removeClass("disable");
            jQuery(".modal .product-button span").removeClass("active");
            jQuery(".modal .product-button span").text("Select");
          }
        }
      }
      if (cart.total_price > 100) {
        if (jQuery("#DiscountSingle-10").length > 0) {
          var show_sigle_offer = true;
          var campaign = jQuery("#DiscountSingle-10").attr("data-campaign");
          var product = jQuery("#DiscountSingle-10").attr("data-product");
          var limit = jQuery("#DiscountSingle-10").attr("data-limit");

          for (var i = 0; i < cart.items.length; i++) {
            var variant_id = cart.items[i].variant_id;
            if (
              variant_id == product ||
              variant_id == 44794297090370 ||
              variant_id == 44794297123138
            ) {
              var show_sigle_offer = false;
            }
          }

          if (show_sigle_offer == true) {
            data = {
              id: product,
              quantity: limit,
            };

            console.log(data);

            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: data,
              dataType: "json",
              success: function () {
                cart_sidebar_update();
              },
              error: function (xhr, text) {
                cart_sidebar_update();
              },
            });
          }
        }
      }
    });
  }

  jQuery(document).delegate(
    ".discounts .product-button span",
    "click",
    function (e) {
      if (jQuery(this).text() == "Select") {
        jQuery(this).text("Selected");
        jQuery(this).siblings("input").attr("checked", true);
      } else {
        jQuery(this).text("Select");
        jQuery(this).siblings("input").attr("checked", false);
      }
      jQuery(this).toggleClass("active");
      PopupCount();
    }
  );

  function PopupCount() {
    var total = jQuery(".discounts").find('input[name="id[]"]:checked').length;
    var limit = jQuery(".discounts").data("limit");
    console.log("PopupCount");
    console.log(total);
    console.log(limit);
    if (total >= limit) {
      jQuery(".discounts .product-button span")
        .not(".active")
        .addClass("disable");
    } else {
      jQuery(".discounts .product-button span")
        .not(".active")
        .removeClass("disable");
    }
  }

  jQuery(document).delegate(".bogo-offer .button span", "click", function (e) {
    if (jQuery(this).text() == "Select") {
      jQuery(this).text("Selected");
      jQuery(this).siblings("input").attr("checked", true);
    } else {
      jQuery(this).text("Select");
      jQuery(this).siblings("input").attr("checked", false);
    }
    jQuery(this).toggleClass("active");
    BogoCount();
  });

  function BogoCount() {
    var total = jQuery(".bogo-offer").find('input[name="id[]"]:checked').length;
    var limit = jQuery(".bogo-offer").data("limit");
    if (total >= limit) {
      jQuery(".bogo-offer .button span").not(".active").addClass("disable");
    } else {
      jQuery(".bogo-offer .button span").not(".active").removeClass("disable");
    }
  }

  jQuery(document).delegate(".checkout-popup", "click", function (e) {
    if (oilty_gift == true && oilty_status == true) {
      var total_price = jQuery("#cart-value").val();
      var popup_type = jQuery("#cart-type").val();

      if (popup_type == "annually") {
        total_price = total_price - 9995;
      }

      console.log(total_price);

      if (total_price > 100) {
        window.location.href = "/checkout";
      }

    } else {
      console.log("checkout");
      window.location.href = "/checkout";
    }
  });

  jQuery(".oilty-options").change(function () {
    console.log(this.value);
    if (this.value == "44794297090370") {
      jQuery("#checkout-selling-id").val(
        jQuery("#checkout-selling-id").data("monthly")
      );
    } else {
      jQuery("#checkout-selling-id").val(
        jQuery("#checkout-selling-id").data("yearly")
      );
    }
  });
});
